// extracted by mini-css-extract-plugin
export default {"Header":"styles_Header__0PzRT","HeaderRightSideDiv":"styles_HeaderRightSideDiv__K+MB6","ButtonsDiv":"styles_ButtonsDiv__eMdBO"};